module.exports = __webpack_public_path__ + "static/media/DSC_0878.ac0ed1b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/events/DSC_0878.jpg
// module id = 611
// module chunks = 0